import Certifiacation from './education/Certification';
import Degree from './education/Degree';

const Education = () => {
  return (
    <>
      <h2>Education</h2>

      <Certifiacation />

      <Degree />
    </>
  );
};

export default Education;
